import { useState } from "react";
import { NoRealData } from "@/components/shared";
import {
  ctaReports,
  environmentalReports,
  carbonReports,
  documentaryReports,
} from "@/config/relat-oper-ladm-relatorios-config";
import ReportTemplatesGrid from "./components/ReportTemplatesGrid";
import ReportCatalogPanel from "./components/ReportCatalogPanel";

// Nao existe backend de geracao de relatorios. Esta tela mostra apenas o
// que esta previsto (modelos e catalogo por tema); historico, contagens,
// pendencias e exportacoes ficam como "sem dado real" ate haver fonte.

const tabs = [
  { id: "biblioteca", label: "Biblioteca de Relatórios" },
  { id: "modelos", label: "Modelos previstos" },
  { id: "cta", label: "CTA Arbóreo" },
  { id: "projetos", label: "Projetos" },
  { id: "ambiental", label: "Ambiental" },
  { id: "carbono", label: "Carbono" },
  { id: "documental", label: "Documental e RRR" },
  { id: "gis", label: "Exportações GIS" },
];

export default function Relatorios() {
  const [activeTab, setActiveTab] = useState("biblioteca");

  return (
    <div className="space-y-5">
      {/* Header */}
      <div>
        <div className="text-xs text-foreground-500 mb-1">Dashboard &gt; Relatórios</div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">Relatórios</h1>
        <p className="text-sm text-foreground-500 mt-1 max-w-2xl">
          Relatórios técnicos, executivos, cartográficos, fotográficos e ambientais a partir dos dados do CTA, projetos, áreas verdes, carbono e governança.
        </p>
      </div>

      <div className="bg-secondary-50 border border-secondary-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <i className="ri-information-line text-secondary-600 text-lg shrink-0" />
          <p className="text-xs text-secondary-700 leading-relaxed">
            A geração de relatórios ainda não está disponível. Os modelos e o catálogo abaixo descrevem o conteúdo previsto de cada relatório;
            nenhum relatório foi gerado pelo sistema até o momento.
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-background-200">
        <div className="flex gap-1 overflow-x-auto pb-0">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap rounded-t-lg transition-colors border-b-2 ${
                activeTab === tab.id
                  ? "text-primary-700 border-primary-500 bg-primary-50/50"
                  : "text-foreground-500 border-transparent hover:text-foreground-700 hover:bg-background-50"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="min-h-[300px]">
        {activeTab === "biblioteca" && (
          <NoRealData
            variant="page"
            icon="ri-article-line"
            title="Biblioteca de relatórios gerados"
            description="Aqui aparecerão os relatórios gerados, com tipo, projeto, período, responsável, formato e situação de revisão. Ainda não há serviço de geração nem histórico de relatórios."
          />
        )}

        {activeTab === "modelos" && (
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-foreground-900">Modelos de relatório previstos</h3>
            <p className="text-xs text-foreground-500">
              Estrutura padrão prevista para cada relatório: finalidade, público, seções e formatos de saída.
            </p>
            <ReportTemplatesGrid />
          </div>
        )}

        {activeTab === "cta" && <ReportCatalogPanel title="Relatórios previstos — CTA Arbóreo" items={ctaReports} />}

        {activeTab === "projetos" && (
          <NoRealData
            icon="ri-folder-chart-line"
            title="Relatórios por projeto"
            description="Aqui aparecerão os relatórios gerados para cada projeto (técnico, progresso, campo, qualidade do cadastro). Ainda não há relatórios gerados."
          />
        )}

        {activeTab === "ambiental" && <ReportCatalogPanel title="Relatórios previstos — Ambiental" items={environmentalReports} />}

        {activeTab === "carbono" && <ReportCatalogPanel title="Relatórios previstos — Carbono" items={carbonReports} />}

        {activeTab === "documental" && <ReportCatalogPanel title="Relatórios previstos — Documental e RRR" items={documentaryReports} />}

        {activeTab === "gis" && (
          <NoRealData
            icon="ri-map-2-line"
            title="Exportações GIS"
            description="Aqui aparecerão as exportações de camadas (GeoJSON, Shapefile, KML/KMZ) com camada, projeto, SRID e quantidade de feições. Ainda não há serviço de exportação nem histórico."
          />
        )}
      </div>
    </div>
  );
}
